/** Overview is exact-only; other links match the path or nested routes. */
export const isSidebarLinkActive = (pathname: string, to: string): boolean => {
  if (to === "/dash/admin") {
    return pathname === "/dash/admin" || pathname === "/dash/admin/";
  }
  return pathname === to || pathname.startsWith(`${to}/`);
};
